import {collection, component, EntityData, field, identifier, transientIdentifier} from "@fedeltapointofsale/data-client";
import {CategoryReferenceData} from "../category/category.data";
import {AbstractSellableData} from "../sellable/sellable.data";
import {StringUtils} from "../../framework/utils/string-utils";

export class CompositeProductComponentProductLineData extends EntityData<CompositeProductComponentProductLineData> {
    @identifier sellableId: number;
    @field name: string;
    @field price: number;
    @field discontinued: boolean;
    @component primaryCategory: CategoryReferenceData;
}

export class CompositeProductComponentPlgSellableSellableData extends EntityData<CompositeProductComponentPlgSellableSellableData> {
    @identifier sellableId: number;
    @field name: string;
    @field discontinued: boolean;
}

export class CompositeProductComponentPlgSellableData extends EntityData<CompositeProductComponentPlgSellableData> {
    @component sellable: CompositeProductComponentPlgSellableSellableData;
}

export class CompositeProductComponentPlgData extends EntityData<CompositeProductComponentPlgData> {
    @identifier plgId: number;
    @field name: string;
    @component primaryCategory: CategoryReferenceData;
    @collection(CompositeProductComponentPlgSellableData) sellableLines: CompositeProductComponentPlgSellableData[];
}

export class CompositeProductComponentData extends EntityData<CompositeProductComponentData> {
    @field qty: number = 1; // This is deprecated but must still be set to 1
    @field compositeLinePrice: number;
    @component productLine: CompositeProductComponentProductLineData;
    @component plg: CompositeProductComponentPlgData;

    transientId: string = StringUtils.uuid();

    _componentType: string;

    get componentType(): string {
        return this._componentType ? this._componentType :
            this.productLine && this.productLine.sellableId ? "ProductLineQtyData" :
                this.plg && this.plg.plgId ? "ProductLinePlgQtyData" :
                    undefined;
    }

    @field
    set componentType(componentType: string) {
        this._componentType = componentType;
    }

    @transientIdentifier
    get id(): string {
        return this.transientId;
    }

    get name(): string {
        return this.productLine && this.productLine.sellableId ? this.productLine.name :
            this.plg && this.plg.plgId ? this.plg.name :
                undefined;
    }

    get category(): string {
        return this.productLine && this.productLine.sellableId ? this.productLine.primaryCategory.name :
            this.plg && this.plg.plgId ? this.plg.primaryCategory.name :
                undefined;
    }

    get price(): number {
        return this.productLine && this.productLine.sellableId ? this.productLine.price : undefined;
    }

    get available(): boolean {
        return this.productLine && this.productLine.sellableId ? !this.productLine.discontinued :
            this.plg && this.plg.plgId ? this.plg.sellableLines.find((sellableLine: CompositeProductComponentPlgSellableData) => sellableLine.sellable.discontinued) == undefined :
                undefined;
    }
}

export class CompositeProductData extends AbstractSellableData<CompositeProductData> {
    sellableType: string = "CompositeProductData"; // allows assignment to a SellableData
    @collection(CompositeProductComponentData) components: CompositeProductComponentData[];
}
